import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ProgressWithSkip } from "../generic/progress-with-skip/ProgressWithSkip";
import { ContextMenuResourceAmount } from "./ContextMenuResourceAmount";
export var ContextMenuRunningProcess = function (_a) {
    var onSkip = _a.onSkip, building = _a.building, skipProcessFactor = _a.skipProcessFactor, getProcessRemainingTime = _a.getProcessRemainingTime, getProcessTotalTime = _a.getProcessTotalTime, icon = _a.icon, tooltipLoca = _a.tooltipLoca, baseAmount = _a.baseAmount, buffAmount = _a.buffAmount, children = _a.children;
    var iconTextComponent = baseAmount ? (React.createElement(ContextMenuResourceAmount, { baseAmount: baseAmount, buffAmount: buffAmount })) : (React.createElement(React.Fragment, null));
    return (React.createElement("div", { className: "flex flex--guts " + IdStyles.ContextMenuRunningProductionBuildingWrapper },
        React.createElement("div", { className: "flex flex--end context-menu-fixed-running-process " + IdStyles.ContextMenuRunningProductionBuilding },
            React.createElement(ProgressWithSkip, { duration: getProcessTotalTime(building), onSkip: function () { return onSkip(building); }, skipProcessFactor: skipProcessFactor, remainingTime: getProcessRemainingTime(building), icon: icon, iconTextComponent: iconTextComponent, tooltipLoca: tooltipLoca, children: children }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuRunningProcess.tsx
// module id = 584
// module chunks = 3